import { render, staticRenderFns } from "./activitydetails.vue?vue&type=template&id=7377926e&scoped=true"
import script from "./activitydetails.vue?vue&type=script&lang=js"
export * from "./activitydetails.vue?vue&type=script&lang=js"
import style0 from "./activitydetails.vue?vue&type=style&index=0&id=7377926e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7377926e",
  null
  
)

export default component.exports